import { configureStore } from '@reduxjs/toolkit';
import app from '../App/ducks';
import settings from '../Settings/ducks';
import { jwtListener, jwtMiddleware, jwtReducer } from './jwtMiddleware';

const initializeStore = () => {
  const rootReducer = {
    settings,
    app,
    token: jwtReducer,
  };

  const store = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
      [jwtMiddleware].concat(
        getDefaultMiddleware({
          immutableCheck: false,
        })
      ),
  });

  store.subscribe(() => jwtListener(store.getState()));

  return store;
};

export default initializeStore;
